import { useMutation } from 'react-query'
import {
  startSharingAttachment,
  stopSharingAttachment,
} from '../api/attachment'

export function useStartSharingAttachment(liveId: string, filename: string) {
  return useMutation({
    mutationKey: ['start-sharing', liveId, filename],
    mutationFn: () => startSharingAttachment(liveId, filename),
  })
}

export function useStopSharingAttachment(liveId: string, filename: string) {
  return useMutation({
    mutationKey: ['start-sharing', liveId, filename],
    mutationFn: () => stopSharingAttachment(liveId, filename),
  })
}
